import { createFileRoute, redirect } from '@tanstack/react-router'
import { Loader2 } from 'lucide-react'

export const Route = createFileRoute('/')({
  component: IndexPage,
  beforeLoad: ({ location }) => {
    // PR #8 redirect-loop guard: when Logto's hosted login round-trips a
    // stale bookmark back to `/?code=...` instead of `/callback`, let the
    // upstream LogtoProvider observe the code and trigger the callback
    // flow rather than redirecting away to /dashboard mid-exchange.
    const search = location.search as Record<string, unknown> | undefined
    if (search && 'code' in search) {
      return
    }
    throw redirect({ to: '/dashboard' })
  },
})

function IndexPage() {
  return (
    <div className="flex min-h-screen items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
    </div>
  )
}
